<!-- <div
  class="flex"
  [ngClass]="router.url !== '/dashboard/GuideLines' ? 'mb-[5rem]' : 'mb-[0rem]'"
> -->
<div
  class="flex"
  [ngClass]="
    router.url !== '/dashboard/GuideLines' &&
    router.url !== '/dashboard/wallet' &&
    router.url !== '/dashboard/account' &&
    router.url !== '/dashboard/credentials' &&
    router.url !== '/dashboard/redeem' &&
    router.url !== '/dashboard/TreasurePick' &&
    router.url !== '/dashboard/Baccaret' &&
    router.url !== '/dashboard/Keno' &&
    router.url !== '/dashboard/Roulette' &&
    router.url !== '/dashboard/StackBuilder' &&
    router.url !== '/dashboard/Mines' &&
    router.url !== '/dashboard/Plinko'
      ? 'mb-[1rem]'
      : 'mb-[0rem]'
  "
>
  <!-- &&
    router.url !== '/dashboard/SectrechCards' &&
    router.url.startsWith('dashboard/buy-now') -->
  <div
    *ngIf="!isHiddenSidebarRoute()"
    class="md:w-[240px] w-[0%] flex-shrink-0"
  >
    <app-side-bar></app-side-bar>
  </div>
  <div
    [ngClass]="[
      isHiddenSidebarRoute() ||
      router.url === '/dashboard/Plinko' ||
      router.url === '/dashboard/Avaitar' ||
      router.url === '/dashboard/Baccaret' ||
      router.url === '/dashboard/Roulette' ||
      router.url === '/dashboard/Mines' ||
      router.url === '/dashboard/Keno' ||
      router.url === '/dashboard/StackBuilder'
        ? 'w-[100%]'
        : 'md:w-[calc(100%-240px)] w-[100%]',
      isSpinnerModule() ? 'lg:mb-0' : '',
    ]"
  >
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<!-- <div>
  <app-footer></app-footer>
</div> -->
